import { Col, Form, Row } from 'antd';
import { Button } from 'components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import { useForm } from 'antd/lib/form/Form';
import { get } from 'lodash';
import { useParams, useNavigate } from 'react-router-dom';
import CarrierUsers from './carrierUsers';
import { useSupplierType } from 'hooks/useSupplierType';
import { isBeneficiary, isValidUpdateCarrierUsers , outcomes , handleCarrierUsers } from 'utils';
import moment from 'moment';
import { size, cloneDeep } from 'lodash';
import { handleSubmit } from 'utils';
import { submitTask , submitTaskCarriers } from 'store/forms/actions';
import { ReactComponent as Cancel } from 'assets/icons/cancel_icon.svg';
import { SubmitModal } from 'components/layout/components';
// import { Tooltip } from 'antd';
// import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
// import { isCarrierUsersValidSupplier } from 'utils';

const CarrierCompositionDetails = ({ disabled, extended }) => {
  const user = useSelector(state => state.user);
  const carrier = useSelector(state => state.forms.carrier);
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  const forms = useSelector(state => state.forms);
  const task = useSelector(state => state.forms.task);
    const [isVisible, setIsVisible] = useState(false);
    const submitDisabled = useSelector(state => state.forms.submitting);
    const [outcome, setOutcome] = useState('');
    const params = useParams();
    const state = useSelector(state => state.forms);
    const formId = useSelector(state => state.forms.formId);
    const navigate = useNavigate();
    const businessKey = useSelector(state => state.forms.businessKey);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || 
                    !isBeneficiary(user.groups) || 
                    applicationReturned && activeTaskName !== "task.name.accepted" ||
                    activeTaskName === "task.name.temporary_rejected" ||
                    activeTaskName === "task.name.application_returned_to_supplier";
  const [form] = useForm();
  const dispatch = useDispatch();
  const [sameMasterUser, setSameMasterUser] = useState(false);

  const carrierUsers = useSelector(
    state => state.forms.carrier.carrierUsers
  ) || [
    {
      userLName: carrier?.companyName ? carrier?.companyName : '',
      userPhone: carrier?.invMob ? carrier?.invMob : '',
      userEmail: carrier?.invMail ? carrier?.invMail : '',
      id:carrier?.id ? carrier?.id : null,
    },
  ];

  const carrierUsersStatic = useSelector( 
    state => state.forms?.carrierUsersStatic?.carrierUsers
  ) 

  const handleChangeUsers = ({ key, value }) => {
    dispatch(updateFormField({ group: 'carrier', key, value }));
  };

  //Initialize carrierUsers on mount if carrierUsers is empty
  useEffect(() => {
    if(activeTaskName ==='task.name.submit_application'){
    if (!carrier?.carrierUsers || carrier?.carrierUsers.length === 0) {
      const masterUser = {
        id:null,
        userLName: carrier?.companyName || '',
        userPhone: carrier?.invMob || '',
        userEmail: carrier?.invMail || '',
      };

      dispatch(updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value: [masterUser]
      }));
    }
    }
  }, []);

  const isExistingUser = (user) => {
    return carrierUsersStatic?.some(staticUser => {
      return staticUser?.id && staticUser?.id === user?.id;
    });
  };

  const canAddMoreUsers = () => {
  if (!Array.isArray(carrierUsersStatic) || carrierUsersStatic.length === 0) {
    return true; // No static users to compare against
  }

  return (carrierUsers.length - carrierUsersStatic.length) < 5;
};

  // useEffect(() => {
  //     //The master user must be in first index, where index 0 is disabled
  //     const masterUser = {
  //       userLName: carrier?.companyName || '',
  //       userPhone: carrier?.invMob || '',
  //       userEmail: carrier?.invMail || '',
  //     };

      
  //     // Remove any existing user that matches the carrier info (based on userLName = companyName)
  //     const filteredUsers = carrierUsers.filter(
  //       (user) =>
  //         user.userLName !== masterUser.userLName &&
  //         user.userPhone !== masterUser.userPhone &&
  //         user.userEmail !== masterUser.userEmail
  //     );

  //     // Ensure masterUser is first
  //     const finalUsers = [masterUser, ...filteredUsers];

  //     if (!isEqual(carrierUsers, finalUsers)) {
  //      setSameMasterUser(true);
  //      dispatch(
  //       updateFormField({
  //         group: 'carrier',
  //         key: 'carrierUsers',
  //         value: finalUsers
  //       })
  //       );
  //     }
  // }, [carrierUsers, carrier?.invMail, carrier?.invMob, carrier?.companyName]);
  

  const addMore = () => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value: [
          ...carrierUsers,
          {
            userLName: '',
            userPhone: '',
            userEmail: '',
            id:null
          },
        ],
      })
    );
  };

  const removeUser = key => {
    const value = carrierUsers.filter((_, index) => index !== key);
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'carrierUsers',
        value,
      })
    );
  };

  useEffect(() => {
    if (size(carrierUsers) <1) {
      addMore()
    }
  },[carrierUsers]) 
  


  const renderUsers = () =>
  carrierUsers.map((item, index) => {
    const disableEmail = isExistingUser(item);
    return (
      <CarrierUsers
        item={item}
        key={index}
        index={index}
        disabled={viewMode}
        disableEmail={disableEmail}
        removeUser={removeUser}
        update={({ key, value, index }) => {
          const newUsers = [...carrierUsers];
          newUsers[index] = {
            ...newUsers[index],
            [key]: value,
          };
          handleChangeUsers({
            key: 'carrierUsers',
            value: newUsers,
          });
        }}
        carrierUsers={carrierUsers}
        addUsers={addMore}
      />
    )
});

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  useEffect(() => {
    var newValues = cloneDeep(carrierUsers);
    form.setFieldsValue({ carrierUsers: newValues });

    const fieldsToValidate = newValues.flatMap((user, index) => {
      const { userLName, userPhone, userEmail } = user;
  
      // Skip validation if all three fields are empty
      const isAllEmpty = !userLName && !userPhone && !userEmail;
      if (isAllEmpty) return [];
  
      // Otherwise, include the relevant fields for validation
      return [
        ['carrierUsers', index, 'userLName'],
        ['carrierUsers', index, 'userEmail'],
        ['carrierUsers', index, 'userPhone']
      ];
    });
  
    form.validateFields(fieldsToValidate);
  }, [carrier.carrierUsers]);

  return (
    <div>
      <SubmitModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        submitDisabled={submitDisabled}
        formKey={task.formKey}
        outcome={outcome}
        businessKey={businessKey}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible,
            taskId: params.taskId,
            formId,
            formKey: task.formKey,
            outcome,
            activeTaskName
          })
        }
        handleCarrierUsers={() =>
          handleCarrierUsers({
            state: { ...state },
            user: { ...user },
            dispatch,
            submitTaskCarriers,
            navigate,
            setIsVisible,
            taskId: params.taskId,
            formId,
            formKey: task.formKey,
            outcome,
            activeTaskName
          })
        }
      />
      <Form
        form={form}
        name="carrierUsers"
        initialValues={{ ...carrier?.carrierUsers }}
        preserve={false}
      >
        <div className="stepper-warning-message">
          Ο χρήστης της Επιχείρησής σας αποτελεί Master User και μπορείτε να διαχειριστείτε όλες τις αιτήσεις που τον αφορούν.<br/>
          Δεν είναι δυνατή η αποθήκευση και η υποβολή της αίτησης εάν τα πεδία "Επωνυμία / Ονοματεπώνυμο", "Τηλέφωνο Επικοινωνίας" και "E-mail Επικοινωνίας" δεν είναι μοναδικά για κάθε χρήστη.
        </div>
       { sameMasterUser && 
          <div className="stepper-warning-message error-message">
          Δεν μπορείτε να εισάγετε νέο χρήστη ίδιο με αυτό του Master User.
          <Cancel className="cancel-icon"  onClick={() => setSameMasterUser(false)} />
          </div>}
        <div
          className="carrier-data-form mt-2"
          style={{ 
            width: '100%', 
            display: 'flex',        // use flexbox
            alignItems: 'center',   // vertically center them
            justifyContent: 'space-between' // push them apart if you want spacing
          }}
        >
          <p className="mt-0 mr-0 color-blue-3 text-bold font-size-24">
            Διαχείριση Χρηστών
          </p>
          { !viewMode && isBeneficiary(user?.groups) &&  task.taskName === "task.name.accepted" && isDirectSupplier &&
              // user.privileges?.includes("CanRenderSubmitBtn") && 
              (
                <Button
                  type="default"
                  id="submit-carrier-users"
                  className={"saveButton"}
                  // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
                  label={'Ανανέωση Χρηστών'}
                  disabled={ 
                    isValidUpdateCarrierUsers(forms?.carrierUsersStatic,forms?.carrier?.carrierUsers,forms)
                }
                  onClick={() => {
                    setOutcome(outcomes.updateCarrierUsers);
                    setIsVisible(true);                    
                  }}
                />
              )}
            </div>
            <Row
              gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
              className="shareHoldersWrapper"
            >
              <Col span={24}>{renderUsers()}</Col>

              {(!viewMode && canAddMoreUsers()) && (
                <Row justify="end" style={{ width: '100%' }}>
                  <Col>
                    <Button
                      className="mt-2 addMoreBtn"
                      label={'Προσθήκη'}
                      onClick={addMore}
                      disabled={viewMode}
                    />
                  </Col>
                </Row>
              )}
            </Row>
      </Form>
    </div>
  );
};

export default CarrierCompositionDetails;
